import { lazy } from 'react'

export const BlockArrayLazy = lazy(() =>
    import('./BlockArray').then((component) => ({
        default: component.BlockArray,
    }))
)
